import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Globe, Inbox, LogOut, User } from 'lucide-react';
import { AppShell, BenachrichtigungenProvider, useBenachrichtigungen } from '@elbklar/ui';
import { useAuth } from '@/features/auth/AuthContext';
import { SchnellErfassenProvider, useSchnellErfassen } from '@/features/schnell-erfassen';
import { benachrichtigungenApi } from '@/lib/api';
import { kontoUrl } from '@/lib/konto';
import { RouterLink } from './RouterLink';

/**
 * Rahmen des PM nach dem Elbklar Design System: schwebende Sidebar links,
 * Inhalt rechts. Jede Seite bringt ihren eigenen PageHeader mit.
 * Unter 768 px die Tab-Leiste unten (Mobil M1): Meine Arbeit · + · Mehr.
 * „+“ öffnet Schnell erfassen, „Mehr“ zeigt Website und den Fuß der Sidebar.
 * Benachrichtigungen kommen aus dem zentralen Modul von @elbklar/ui.
 */
export function PMLayout() {
  const navigate = useNavigate();
  return (
    <BenachrichtigungenProvider app="pm" api={benachrichtigungenApi} navigieren={navigate} kontoEinstellungen={() => kontoUrl('/benachrichtigungen')}>
      <SchnellErfassenProvider>
        <Rahmen />
      </SchnellErfassenProvider>
    </BenachrichtigungenProvider>
  );
}

function Rahmen() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { oeffnen } = useSchnellErfassen();
  const benachrichtigungen = useBenachrichtigungen();

  // Projektseiten gehören zu „Meine Arbeit“: Dort kommt man hin.
  const aktiv = pathname.startsWith('/website') ? 'website' : 'meine-arbeit';

  return (
    <AppShell
      sidebar={{
        app: 'PM',
        search: false,
        activeId: aktiv,
        linkAs: RouterLink,
        sections: [
          { items: [{ id: 'meine-arbeit', label: 'Meine Arbeit', icon: Inbox, href: '/' }] },
          { label: 'Extras', items: [{ id: 'website', label: 'Website', icon: Globe, href: '/website' }] },
        ],
        // Benachrichtigungen zuerst, wie im CRM (derselbe Ort in jeder App); Profil
        // liegt zentral auf konto.elbklar.com.
        footer: [
          benachrichtigungen.eintrag,
          { id: 'profil', label: 'Profil', icon: User, href: kontoUrl('/profil') },
          { id: 'abmelden', label: 'Abmelden', icon: LogOut },
        ],
        onSelect: async (id) => {
          if (benachrichtigungen.waehlen(id)) return;
          if (id === 'abmelden') {
            await logout();
            navigate('/login');
          }
        },
      }}
      mobilNav={{
        tabs: ['meine-arbeit'],
        schnellErfassen: { label: 'Schnell erfassen', onClick: () => oeffnen() },
      }}
    >
      <Outlet />
    </AppShell>
  );
}
